/*
 * @Date: 2019-08-09 19:49:42
 * @LastEditors: hzgegenhasi@corp.netease.com
 * @LastEditTime: 2019-08-09 19:49:42
 * @Author: hzgegenhasi@corp.netease.com
 */
import { message } from 'antd';
import moment from 'moment';
import { ofType } from 'redux-observable';
import { map, switchMap } from 'rxjs/operators';
import { TIME_INFINITE } from './const';
import { Type } from './redux';

/**
 * 获取讨论内容
 */

const getPost = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_POST),
    switchMap(({ postId, classroomId }) =>
      fetch({
        url: '/mm-classroom/web/j/forumRpcBean.getPost.rpc',
        body: {
          postId,
          classroomId,
        },
      }),
    ),
    map(content => {
      return {
        type: Type.GET_POST_SUCCESS,
        postContent: {
          ...content,
          // 转为数组
          images: content.images ? JSON.parse(content.images) : [],
          publishTimeText: content.publishTime
            ? moment(content.publishTime).format('YYYY-MM-DD HH:mm')
            : '',
        },
      };
    }),
  );

const getReplyList = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.GET_REPLY_LIST),
    switchMap(({ postId, pageSize = 20, beforeTime = TIME_INFINITE }) =>
      fetch({
        url: '/mm-classroom/web/j/forumReplyRpcBean.getReplyPage.rpc',
        body: {
          postId,
          pageSize,
          beforeTime,
        },
      }),
    ),
    map(({ totalReplyStudentCount = 0, replyPage = { list: [] } }) => ({
      type: Type.GET_REPLY_LIST_SUCCESS,
      // 发言学生总数
      total: totalReplyStudentCount,
      query: replyPage?.query ?? {},
      // 评论列表
      list: replyPage.list
        ? replyPage.list.map(item => {
            // 裁剪用户头像
            const avator =
              item.headImageUrl ||
              'https://edu-image.nosdn.127.net/49E89BEA3F1B3F1AC788F5F94C4A457F.png';

            const formatTime = time => {
              const now = new Date();
              const date = new Date(time);

              const isSameDay = now.getDay() === date.getDay();
              const isSameYear = now.getFullYear() === date.getFullYear();

              // 同一天，显示时间
              if (isSameDay) {
                return moment(time).format('HH:mm');
              }
              // 同一年，显示月日
              if (isSameYear) {
                return moment(time).format('MM月DD日');
              }

              return moment(time).format('YYYY年MM月DD日');
            };

            const formatImages = images => {
              let arr = [];
              if (!images) {
                return arr;
              }
              try {
                arr = JSON.parse(images);
              } catch (e) {
                arr = [];
              }

              return arr;
            };

            return {
              ...item,
              // 格式化提交时间
              replyTimeFormat: item.replyTime
                ? formatTime(item.replyTime)
                : '--',
              avator,
              // 优秀发言
              tagAgreeText: item.tagAgree ? '精彩发言' : '',
              // 图片
              images: formatImages(item.images),
              // 是否可删除
              deletable:
                item.replierId == state$.value.mirroring.post.userInfo?.id,
            };
          })
        : [],
    })),
  );

const like = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.LIKE),
    switchMap(({ postId, targetId, targetType = 2, agree }) =>
      fetch({
        url: '/mm-classroom/web/j/forumRpcBean.markVote.rpc',
        body: {
          postId,
          targetId,
          targetType,
          agree,
        },
      }).pipe(
        map(countVote => {
          const updateList = count => {
            const {
              value: {
                mirroring: {
                  post: { list },
                },
              },
            } = state$;
            const index = list.findIndex(item => {
              return item.id === targetId;
            });
            if (index === -1) {
              return list;
            }

            return [
              ...list.slice(0, index),
              {
                ...list[index],
                countVote: count,
                agree,
                // 优秀发言
                tagAgreeText:
                  agree && state$.value.mirroring.post.needLikeGuide
                    ? '优秀发言'
                    : '',
              },
              ...list.slice(index + 1),
            ];
          };
          return {
            type: Type.LIKE_SUCCESS,
            list: updateList(countVote),
          };
        }),
      ),
    ),
  );

const deleteReply = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.DELETE_REPLY),
    switchMap(({ replyId }) =>
      fetch({
        url: '/mm-classroom/web/j/forumReplyRpcBean.deleteReply.rpc',
        body: {
          replyId,
        },
      }).pipe(
        map(res => {
          const updateList = () => {
            const {
              value: {
                mirroring: {
                  post: { list },
                },
              },
            } = state$;
            const index = list.findIndex(item => {
              return item.id === replyId;
            });
            if (index === -1) {
              return list;
            }

            return [...list.slice(0, index), ...list.slice(index + 1)];
          };
          return {
            type: Type.DELETE_REPLY_SUCCESS,
            list: updateList(),
          };
        }),
      ),
    ),
  );

const nextPage = (action$, state$) =>
  action$.pipe(
    ofType(Type.NEXT_PAGE),
    map(({ postId }) => {
      return {
        type: Type.GET_REPLY_LIST,
        pageSize: state$.value.mirroring.post.currentPageSize,
        beforeTime: state$.value.mirroring.post.beforeTime,
        postId,
      };
    }),
  );

const getReplyUserTotal = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.DELETE_REPLY_SUCCESS),
    switchMap(() =>
      fetch({
        url: '/mm-classroom/web/j/forumReplyRpcBean.countPostReplyMember.rpc',
        body: {
          postId:
            state$.value.ws.socketData.classroomDataTransportFromWl.postId,
        },
      }),
    ),
    map(total => {
      return {
        type: Type.GET_REPLY_USER_TOTAL_SUCCESS,
        total,
      };
    }),
  );

/**
 * 删除评论中的回复
 */
const deleteComment = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.DELETE_COMMENT),
    switchMap(({ postId, commentId, replyId }) =>
      fetch({
        url: '/mm-classroom/web/j/forumCommentRpcBean.deleteComment.rpc',
        body: {
          postId,
          commentId,
        },
      }).pipe(
        map(res => {
          const updateList = () => {
            const {
              value: {
                mirroring: {
                  post: { list },
                },
              },
            } = state$;

            // 找出当前的评论
            const item = list.find(({ id }) => {
              return id === replyId;
            });

            // 删除失败或者当前评论不在，返回老数据
            if (!res || !item) {
              message.warning('删除失败');
              return {
                type: Type.DELETE_COMMENT_FAILED,
                list,
              };
            }

            // 当前回复序号
            const index = item?.mocCommentList.findIndex(({ id }) => {
              return id === commentId;
            });

            // 没有当前回复，返回老数据
            if (index === -1) {
              return {
                type: Type.DELETE_COMMENT_SUCCESS,
                list,
              };
            }

            // 当前评论序号
            const replyIndex = list.findIndex(({ id }) => {
              return id === replyId;
            });
            // 当前评论下的所有回复
            item.mocCommentList.splice(index, 1);

            message.success('删除成功');

            list.splice(replyIndex, 1, {
              ...list[replyIndex],
              mocCommentList: item.mocCommentList,
            });

            // 删除当前回复，合并数据
            return {
              type: Type.DELETE_COMMENT_SUCCESS,
              list: [...list],
            };
          };

          const { type, list } = updateList();

          return {
            type,
            list,
          };
        }),
      ),
    ),
  );

export default [
  getPost,
  getReplyList,
  like,
  deleteReply,
  nextPage,
  getReplyUserTotal,
  deleteComment,
];
